// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"SectionContainer_sectionContainer__k_ZqP"};